import actionTypes from 'redux/actionTypes';
import 'redux/reducers/location';

export const updateLocation = (location) => ({
    type: actionTypes.LOCATION_UPDATE,
    payload: location,
});
